// extracted by mini-css-extract-plugin
export default {"Header":"Intro_Header__t021c","Text":"Intro_Text__uNisq"};